module.exports = __webpack_public_path__ + "static/media/amazon-badge.dd30abb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-store-icons/amazon-badge.png
// module id = 326
// module chunks = 0